import { environment } from './../../../../../../environments/environment';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ImportConfigurationSftpFormType } from './configuration-form-sftp-form-type';
import { ImportConfigurationEditFormsCoordinatorService } from '../import-configuration-edit-forms-coordinator.service';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-configuration-form-sftp',
    templateUrl: './configuration-form-sftp.component.html',
    styleUrls: ['./configuration-form-sftp.component.scss'],
    imports: [ReactiveFormsModule, TranslateModule]
})
export class ConfigurationFormSftpComponent {

  public get configurationFormSftp(): FormGroup<ImportConfigurationSftpFormType> {
    return this.formsCoordinationService.configurationFormSftp;
  }

  public sftpServerUrl = environment.sftpServerUrl;

  constructor(
    public formsCoordinationService: ImportConfigurationEditFormsCoordinatorService,
  ) { }

}
